import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Badge, Button } from 'reactstrap';
import classnames from 'classnames';

import { getOpenState } from '@common/utils/dimension';
import { getWindowState, getActiveDimensions } from '@shared/active_resize_listener/selectors';

import './accordion.scss';

const displayCount = count => (
  <Badge color="default" className="align-self-center" pill>
    {count}
  </Badge>
);

const breakpoint = 992;

class Accordion extends Component {
  constructor(props) {
    super(props);

    this.toggleOpen = this.toggleOpen.bind(this);
    this.toggleEditMode = this.toggleEditMode.bind(this);
    this.onSave = this.onSave.bind(this);

    this.state = {
      open: this.props.alwaysOpen || window.innerWidth >= breakpoint,
      editMode: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.width !== nextProps.windowDimensions.width && !this.props.alwaysOpen) {
      this.setState(
        getOpenState(
          this.props.windowDimensions,
          nextProps.windowDimensions,
          breakpoint,
          this.props.alwaysOpen,
        ),
      );
    }
  }

  onSave() {
    this.setState({ editMode: false });

    if (this.props.onSave) {
      this.props.onSave();
    }
  }

  toggleEditMode() {
    this.setState({ editMode: !this.state.editMode });
    this.props.editable();
  }

  toggleOpen() {
    if (this.props.alwaysOpen) {
      this.setState({ open: true });
    } else {
      this.setState({ open: this.state.width >= breakpoint ? true : !this.state.open });
    }
  }

  headerSection() {
    const { title, object, count } = this.props;
    if (object && title) {
      return (
        <Link onClick={() => this.toggleOpen()}>
          <div className="accordion d-flex py-3 justify-content-between w-100">
            <div>
              <i className={classnames('accordion-icon', object)} /> {title}{' '}
              {this.props.count ? displayCount(count) : null}
              {!this.props.alwaysOpen && this.state.open ? (
                <i className="icon-down d-lg-none accordion-chevron" />
              ) : (
                <i className="icon-right d-lg-none accordion-chevron" />
              )}
            </div>
            {this.props.editable ? (
              <div className="d-none d-lg-block">
                {!this.state.editMode ? (
                  <Button color="link" onClick={this.toggleEditMode}>
                    Edit
                  </Button>
                ) : (
                  <Button color="link" onClick={this.onSave}>
                    Save
                  </Button>
                )}
              </div>
            ) : null}
          </div>
        </Link>
      );
    }
    return null;
  }

  render() {
    return (
      <div className={classnames('accordion-header w-100', this.props.className)}>
        {this.headerSection()}
        {this.state.open && <div className="accordion-contents">{this.props.children}</div>}
      </div>
    );
  }
}

Accordion.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  object: PropTypes.string,
  className: PropTypes.string,
  count: PropTypes.number,
  onSave: PropTypes.func,
  editable: PropTypes.func,
  alwaysOpen: PropTypes.bool,
  windowDimensions: PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
  }),
};

const mapStateToProps = state => ({
  windowState: getWindowState(state),
  windowDimensions: getActiveDimensions(state),
});

export default connect(mapStateToProps)(Accordion);
